module.exports = __webpack_public_path__ + "static/img/bg.ef2e1f56.png";